import { render, staticRenderFns } from "./BenAdvanceHome.vue?vue&type=template&id=ad176b9a&scoped=true"
import script from "./BenAdvanceHome.vue?vue&type=script&lang=js"
export * from "./BenAdvanceHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad176b9a",
  null
  
)

export default component.exports